import { DropDownList, DropDownListChangeEvent, DropDownListProps } from '@progress/kendo-react-dropdowns';
import { GridColumnMenuFilterUIProps, GridFilterOperator } from '@progress/kendo-react-grid';

interface CustomFilterUIDropdownProps extends GridColumnMenuFilterUIProps, DropDownListProps {
  operator: string;
  operators?: GridFilterOperator[];
}

export const CustomFilterUIDropdown = ({ operator, operators, firstFilterProps, defaultItem, ...props }: CustomFilterUIDropdownProps) => {

    const currentOperator = operators?.some(o => o.operator === firstFilterProps.operator) ? firstFilterProps.operator : operator;

    const onOperatorChange = (event: DropDownListChangeEvent) => {
        firstFilterProps.onChange({
          value: firstFilterProps.value,
          operator: event.target.value.operator,
          syntheticEvent: event.syntheticEvent
        });
    }

    const onChange = (event: DropDownListChangeEvent) => {
        if (props.dataItemKey) {
          firstFilterProps.onChange({
            value: event.target.value[props.dataItemKey],
            operator: currentOperator,
            syntheticEvent: event.syntheticEvent
          });
        } else {
          firstFilterProps.onChange({
              value: event.target.value,
              operator: currentOperator,
              syntheticEvent: event.syntheticEvent
          });
        }
    }

    const getValue = () => {
      if (props.data && props.dataItemKey) {
        const dataItemKey = props.dataItemKey;
        return props.data.find(item => item[dataItemKey] === firstFilterProps.value);
      } else {
        return firstFilterProps.value;
      }
    }

    const value = getValue();

    return (
      <div>
        {operators &&
          <DropDownList
            className="mb-2"
            data={operators}
            textField="text"
            dataItemKey="operator"
            value={operators.find(o => o.operator === currentOperator)}
            onChange={onOperatorChange}
          />
        }
        <DropDownList
          {...props}
          onChange={onChange}
          value={value || defaultItem}
        />
      </div>
    );
}